module.exports = __webpack_public_path__ + "img/status-icn_published@3x.d1fce36b.png";